import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.k73_1 = partyId;
        this.l73_1 = name;
        this.m73_1 = email;
        this.n73_1 = pairingRule;
        this.o73_1 = badgesEnabled;
        this.p73_1 = defaultBadgeName;
        this.q73_1 = alternateBadgeName;
        this.r73_1 = callSignsEnabled;
        this.s73_1 = animationsEnabled;
        this.t73_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.k73_1.toString() + ', name=' + toString(this.l73_1) + ', email=' + toString(this.m73_1) + ', pairingRule=' + toString(this.n73_1) + ', badgesEnabled=' + toString(this.o73_1) + ', defaultBadgeName=' + toString(this.p73_1) + ', alternateBadgeName=' + toString(this.q73_1) + ', callSignsEnabled=' + toString(this.r73_1) + ', animationsEnabled=' + toString(this.s73_1) + ', animationSpeed=' + toString(this.t73_1) + ')';
      }
      hashCode() {
        var result = this.k73_1.hashCode();
        result = imul(result, 31) + hashCode(this.l73_1) | 0;
        result = imul(result, 31) + hashCode(this.m73_1) | 0;
        result = imul(result, 31) + hashCode(this.n73_1) | 0;
        result = imul(result, 31) + hashCode(this.o73_1) | 0;
        result = imul(result, 31) + hashCode(this.p73_1) | 0;
        result = imul(result, 31) + hashCode(this.q73_1) | 0;
        result = imul(result, 31) + hashCode(this.r73_1) | 0;
        result = imul(result, 31) + hashCode(this.s73_1) | 0;
        result = imul(result, 31) + hashCode(this.t73_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.k73_1.equals(other.k73_1))
          return false;
        if (!equals(this.l73_1, other.l73_1))
          return false;
        if (!equals(this.m73_1, other.m73_1))
          return false;
        if (!equals(this.n73_1, other.n73_1))
          return false;
        if (!equals(this.o73_1, other.o73_1))
          return false;
        if (!equals(this.p73_1, other.p73_1))
          return false;
        if (!equals(this.q73_1, other.q73_1))
          return false;
        if (!equals(this.r73_1, other.r73_1))
          return false;
        if (!equals(this.s73_1, other.s73_1))
          return false;
        if (!equals(this.t73_1, other.t73_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
